import { render } from "./OldBookQuickDrawer.vue?vue&type=template&id=71a9c130&scoped=true"
import script from "./OldBookQuickDrawer.js?vue&type=script&lang=js&external"
export * from "./OldBookQuickDrawer.js?vue&type=script&lang=js&external"

import "./OldBookQuickDrawer.css?vue&type=style&index=0&id=71a9c130&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a9c130"]])

export default __exports__